import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { useSetUserServiceGroups } from "@/app/useSetUserServiceGroups";
import { useSetUserInformation } from "@/app/useSetUserInformation";

const TOKEN_SHARING_CHANNEL = "token-sharing";
const REQUESTING_TOKEN = "requesting-token";
const LOGOUT_CHANNEL = "logout-channel";

export default /*#__PURE__*/_defineComponent({
  __name: 'BroadcastWrapper',
  setup(__props, { expose: __expose }) {
  __expose();

const bc = new BroadcastChannel(TOKEN_SHARING_CHANNEL);
const store = useStore();
const router = useRouter();
const { setUserServiceGroups } = useSetUserServiceGroups();
const { setUserInformation } = useSetUserInformation();

// Adds broadcast listener before mounting and triggering guards
onBeforeMount(async () => {
  bc.addEventListener("message", async (event) => initBroadcastChannel(event));
});

// Once guards run and redirect links are store, trigger broadcast
onMounted(() => {
  bc.postMessage(REQUESTING_TOKEN);
});

/**
 * Adds the listener to broadcast and receive tokens
 * @param event - Broadcast event
 */
async function initBroadcastChannel(event: any) {
  // If any new tab opens request a token, and broadcast sends it
  if (event.data === REQUESTING_TOKEN) {
    bc.postMessage({
      accessToken: store.getters["user/getToken"],
    });
    // Triggers if any tab select to log out
  } else if (event.data === LOGOUT_CHANNEL) {
    if (store.getters["user/isLoggedIn"])
      await store.dispatch("user/logUserOut");
    // Containing access token to log in tab
  } else if (event.data.accessToken) {
    // Just triggers if tab is not currently log in
    if (!store.getters["user/isLoggedIn"]) {
      const { accessToken } = event.data;
      store.commit("user/setUser", { token: accessToken });

      // Redirection must be before promises or it will show the login screen for a split second
      const redirectUrl = sessionStorage.getItem("redirect_url");
      if (redirectUrl) {
        sessionStorage.removeItem("redirect_url");
        await router.push(redirectUrl);
      } else {
        await router.push("/");
      }

      // As user was not logged in as the application mounted, service and user info
      // have to be loaded.
      const promisesToSettle: Array<Promise<void>> = [
        setUserServiceGroups(),
        setUserInformation(),
      ];

      await Promise.allSettled(promisesToSettle);
    }
  } else {
    // Console error any unexpected event message
    console.error("Broadcast unknown message: ", event.data);
  }
}

const __returned__ = { TOKEN_SHARING_CHANNEL, REQUESTING_TOKEN, LOGOUT_CHANNEL, bc, store, router, setUserServiceGroups, setUserInformation, initBroadcastChannel, onBeforeMount, onMounted, get useStore() { return useStore }, get useRouter() { return useRouter }, get useSetUserServiceGroups() { return useSetUserServiceGroups }, get useSetUserInformation() { return useSetUserInformation } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})